import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NombreComercialFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='NOMBRE COMERCIAL' htmlFor='input-nombreComercial' md={2} alignRightAt='md' />
      <Col md={10}>
        <Field name='nombreComercial'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-nombreComercial'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NombreComercialFormGroup)
